import React from 'react';

import { useEffect } from 'react';
import { useUserInvitationsActions } from './UserInvitationsContext';

import NewOpenUserInvitationsForm from './NewOpenUserInvitationsForm';
import OpenUserInvitationsTable from './OpenUserInvitationsTable';
import UserInvitationRequestsTable from './UserInvitationRequestsTable';

import styles from './UserInvitations.module.scss';

const UserInvitations = () => {
  const { initializeState } = useUserInvitationsActions();

  useEffect(() => {
    initializeState();
  }, []);

  return (
    <>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          Generate And Send Open User Invitations
        </h2>
        <NewOpenUserInvitationsForm />
      </section>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          Open User Invitations
        </h2>
        <OpenUserInvitationsTable />
      </section>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          User Invitation Requests
        </h2>
        <UserInvitationRequestsTable />
      </section>
    </>
  );
}

export default UserInvitations;
